<template>
  <b-row>
    <!--DIAGNOSTICOS -->
    <b-col 
      cols="12" 
    >
      <DiagnosticosList 
        v-model="dataForm.diagnosticos"
        class="my-1"
        :noAdd="!canEditDiagnosticos"
        :noEditItems="!canEditDiagnosticos"
        showDeleted
      />
    </b-col>

    <!--SERVICIOS DE ATENCION MEDICA -->
    <b-col cols="12">
      <b-card style="border: 1px solid #c9c9c9" >
        <h5>Servicios:</h5>

        <b-row>

          <!--ATENCIONES -->

          <div  class="col-12" v-if="showServicioAtenciones">
            <hr style="margin: 40px 0">
            <h5>Atenciones Medicas</h5>
            <b-row v-if="!dataForm.atenciones.length">
              <b-col cols="10" >
                <SearchOpts
                  v-model="atencionSelected"
                  :searchService="searchAtencionByEstablecimiento"
                  :placeholder="'Buscar atencion por nombre o codigo'"
                  :omit="omitAtenciones"
                  :minChars="3"
                />
              </b-col>

              <b-col cols="1" class="d-flex align-items-end">
                <b-button 
                  @click="onAddAtencion()" 
                  variant="warning"
                  size="sm"
                  :disabled="!atencionSelected"
                >
                  <i class="fas fa-plus"/>
                </b-button>
              </b-col>
            </b-row>

            <b-row v-if="dataForm.atenciones.length"> 
              <b-table
                class="col mt-2"
                bordered
                striped
                responsive
                :items="dataForm.atenciones"
                :fields="fieldsTableAtenciones" 
              >
                <template #cell(acciones)="data">
                  <div class="d-flex justify-content-end">
                  
                    <b-button
                      variant="danger"
                      size="sm"
                      @click="removeItemAtencion(data.item.value)"
                    >
                      <font-awesome-icon icon="circle-xmark" style="color: white" />
                    </b-button>
                  </div>
                </template>
              </b-table>
        
            </b-row>

          </div>

          <!--PROCEDIMIENTOS -->

          <div  class="col-12" v-if="tipoAtencion === '1' || tipoAtencion === '4' || tipoAtencion === '3'">
            <hr style="margin: 40px 0">
            <h5>Procedimientos</h5>
            <b-row>
              <b-col cols="10">
                <SearchOpts
                  v-model="procedimientoSelected"
                  :searchService="procedimientosService.searchByQuery"
                  :placeholder="'Buscar procedimiento por nombre o codigo'"
                  :omit="omitProcedimientos"
                  :minChars="3"
                />
              </b-col>

              <b-col cols="1" class="d-flex align-items-center">
                <b-button 
                  @click="onAddProcedimiento()" 
                  variant="warning"
                  size="sm"
                  :disabled="!procedimientoSelected"
                >
                  <i class="fas fa-plus"/>
                </b-button>
              </b-col>

              <b-col cols="12" class="mt-2" v-if="dataForm.procedimientos.length">
                <b-table
                  bordered
                  striped
                  responsive
                  :items="dataForm.procedimientos"
                  :fields="fieldsTableProcedimientos" 
                >
                  <template #cell(acciones)="data">
                    <div class="d-flex justify-content-end">
                    
                      <b-button
                        variant="danger"
                        size="sm"
                        @click="removeItemProcedimiento(data.item.value)"
                      >
                        <font-awesome-icon icon="circle-xmark" style="color: white" />
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </div>
          <!--IMAGENES -->
          <b-col 
            class="col px-2" 
            v-if="tipoAtencion === '1' || tipoAtencion === '3'"
          >
            <hr style="margin: 40px 0">  
            <CrearDerivacionImagen/>
          </b-col>


          <!--LABORATORIO -->
          <b-col 
            class="col-12 px-2"
            v-if="tipoAtencion === '2'" 
          > 
            <hr>
            <CrearDerivacionLaboratorio />
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { procedimientosService } from '@/views/procesoclinico/services';
import { DiagnosticosList, SearchOpts } from '@/shared/components';
import { carteraAtencionesService } from '@/views/atencionMedica/services';
import { mapState } from "vuex";
import { getEstablecimientoLS, comprobarRoles } from "@/shared/helpers";
import { ROLES } from '@/shared/constants';
import CrearDerivacionLaboratorio from "./CrearDerivacionLaboratorio.vue";
import CrearDerivacionImagen      from "./CrearDerivacionImagen.vue";
import { diagnosticoMapper }      from '../../../atencionMedica/helpers';

export default {
  name: 'Step3',

  components: {
    CrearDerivacionImagen,
    CrearDerivacionLaboratorio,
    DiagnosticosList,
    SearchOpts,
  },

  data() {
    return {

      atencionesChecked: false,
      atencionSelected: null,
      omitAtenciones: [],

      procedimientoSelected: null,
      procedimientosService,

      procedimientosOpts: [],

      isLoading:false,

      dataForm:{
        diagnosticos:[],
        procedimientos:[],
        atenciones:[],
        imagenes: [],
      },

      fieldsTableProcedimientos: [
        {
          key: "text",
          label: "Codigo - Descripcion",
          sortable: true,
          thClass: "text-center",
          width: "150px",
        },
        {
          key: "acciones",
          label: "acciones",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
        },
      ],

      fieldsTableAtenciones: [
        {
          key: "text",
          label: "Atencion Medica",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "acciones",
          label: "acciones",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
        },
      ],
    }
  },


  methods: {

    async searchAtencionByEstablecimiento(search){
      const establecimiento = getEstablecimientoLS();
      return carteraAtencionesService.searchByQueryEstablecimiento(search, establecimiento.id);
    },

    onAddProcedimiento() {
      if (!this.procedimientoSelected) return;
      this.dataForm.procedimientos.push(this.procedimientoSelected);
      console.log('Procedimiento agregado:', JSON.stringify(this.dataForm.procedimientos, null, 2));
      this.procedimientoSelected = null;
    },
    onAddAtencion(){
      if(!this.atencionSelected) return;
      this.dataForm.atenciones.push( this.atencionSelected );
      console.log('Atención agregada:', JSON.stringify(this.dataForm.atenciones, null, 2));
      this.atencionSelected  = null;
    },

    removeItemAtencion(value){
      const newList = this.dataForm.atenciones.filter( p => p.value !== value );
      this.dataForm.atenciones = newList;
    },

    removeItemProcedimiento(value){
      const newList = this.dataForm.procedimientos.filter( p => p.value !== value );
      this.dataForm.procedimientos = newList;
    },


    loadDiagnosticos(){

      const estadoDerivacion         = this.stData?.estadoDerivacion;
      const diagnosticosInDerivacion = this.stData?.diagnosticos;
      const diagnosticosInAtencion   = this.stData?.atenmedId?.diaganamSet;

      this.dataForm.diagnosticos = (estadoDerivacion !== '99')
        ? diagnosticosInDerivacion
        : diagnosticoMapper(diagnosticosInAtencion);
    }
  },

  computed: {
    canEditDiagnosticos(){
      const hasRole = comprobarRoles([ROLES.JEFE_MEDICO, ROLES.DOCTOR]);
      return hasRole;
    },
    ...mapState({
      stModalCompletarDerivacion: state => state.derivaciones.modalCompletarDerivacion,
      stData: state => state.derivaciones.modalCompletarDerivacion.zData,
    }),
    tipoAtencion(){
      const tipoAtencionId = this.stModalCompletarDerivacion.zData?.tipoAtencion;
      if(!tipoAtencionId) return null;

      return tipoAtencionId;
    },
    showServicioAtenciones(){
      return ['1', '5', '6', '7'].some( item => item === this.tipoAtencion );
    },

    omitProcedimientos(){
      if(!this.dataForm.procedimientos) return [];
      const omit = this.dataForm.procedimientos.map( item => ({ id: item?.value }) );
      return omit;
    },
  },


  watch: {
    dataForm:{
      deep: true,
      handler(newValue){
        this.$store.commit("setDerivacionesDataForm", { ...newValue  });
      }
    },

  'dataForm.procedimientos': {
    deep: true,
    handler(newValue) {
      console.log('dataForm.procedimientos actualizado:', JSON.stringify(newValue, null, 2));
    }
  },

    stData:{
      deep: true,
      immediate: true,
      handler(newValue){
        this.loadDiagnosticos();
        // this.dataForm.diagnosticos   = newValue.diagnosticos;
        this.dataForm.atenciones     = newValue.atenciones;
        this.dataForm.procedimientos = newValue.procedimientos;
        this.dataForm.imagenes = this.dataForm.imagenes?.length 
          ? this.dataForm.imagenes.filter(item => item && typeof item === 'object' && item.imagenId) 
          : (newValue.imagenes || []).filter(item => item && typeof item === 'object' && item.imagenId);
        // filtrar nulos
        this.dataForm.atenciones = this.dataForm.atenciones.filter( item => item !== null );
        this.dataForm.procedimientos = this.dataForm.procedimientos.filter( item => item !== null );
        this.dataForm.imagenes = this.dataForm.imagenes.filter(item => item !== null);
      }
    }


  },
}
</script>